import {
  forwardRef,
  KeyboardEventHandler,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { noop } from 'lodash';
import { IonButton, IonIcon, IonInput } from '@ionic/react';
import classNames from 'classnames';

import { Color } from '@ionic/core';

import { ICONS_BASE64 } from '../Icon';

import { ChatInputOnSubmitParams, ChatInputElement } from './ChatInput.types';

import styles from './ChatInput.module.scss';

export interface ChatInputProps {
  placeholder?: string;
  className?: string;
  color?: Color;
  disabled?: boolean;
  onSubmit?: (params: ChatInputOnSubmitParams) => void;
  autofocus?: boolean;
}

export const ChatInput = forwardRef<ChatInputElement, ChatInputProps>(
  (
    {
      placeholder,
      className,
      color = 'medium',
      onSubmit = noop,
      disabled,
      autofocus,
    },
    ref
  ) => {
    const [value, setValue] = useState('');
    const input = useRef<HTMLIonInputElement>();

    const handleOnSubmit = () => {
      if (!!value.trim()) {
        onSubmit({ value });
        setValue(() => '');
      }
    };

    const handleOnKeyDown: KeyboardEventHandler<HTMLIonInputElement> = ({
      key,
    }) => {
      if (key === 'Enter') handleOnSubmit();
    };

    useImperativeHandle(ref, () => ({
      focus: () => input.current.setFocus(),
    }));

    return (
      <IonInput
        ref={input}
        disabled={disabled}
        autoFocus={autofocus}
        value={value}
        mode="md"
        fill="outline"
        color={color}
        onIonInput={({ detail: { value } }) => setValue(value)}
        className={classNames(styles.root, styles.input, className)}
        placeholder={placeholder}
        onKeyDown={handleOnKeyDown}
      >
        <IonButton
          slot="end"
          mode="ios"
          color={color}
          size="small"
          onClick={handleOnSubmit}
          disabled={disabled}
          className={classNames(styles.button, styles.end)}
        >
          <IonIcon
            slot="icon-only"
            aria-hidden="true"
            style={{ fontSize: 20 }}
            icon={ICONS_BASE64['arrow-up']}
          />
        </IonButton>
      </IonInput>
    );
  }
);
